import { stripHubPrefix } from '@helpers/hubPath';

const STORAGE_VERSION = 2;

const buildStorageKey = (
  keyName: string,
  hubId: number | string | null
) => {
  return `${keyName}:v${STORAGE_VERSION}:hub_${hubId}`;
};

export const getLastPath = (
  keyName: string,
  hubId: number | string | null
) => {
  return localStorage.getItem(buildStorageKey(keyName, hubId));
};

export const setLastPath = (
  keyName: string,
  hubId: number | string | null,
  path: string
) => {
  localStorage.setItem(buildStorageKey(keyName, hubId), stripHubPrefix(path));
};

export const removeLastPath = (
  keyName: string,
  hubId: number | string | null
) => {
  localStorage.removeItem(buildStorageKey(keyName, hubId));
};

export const getIdFromParamsOrLastPath = (
  paramsId: string | undefined,
  keyName: string,
  hubId: number | string | null,
  pathPattern: RegExp
): number | null => {
  if (paramsId) {
    return parseInt(paramsId, 10);
  }

  const lastPath = getLastPath(keyName, hubId);

  if (lastPath){
    const match = lastPath.match(pathPattern);
    if (match && match[1]) {
      return parseInt(match[1], 10);
    }
  }
  return null;
};
